<!-- =========================================================================================
File Name: UserList.vue
Description: User List page
----------------------------------------------------------------------------------------
Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
Author: Pixinvent
Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="ag-grid-demo">
		<div id="grid-loader" class="vx-card vs-con-loading__container p-6">
			<ag-grid-vue
				ref="agGridTable"
				:components="components"
				:gridOptions="gridOptions"
				class="ag-theme-material w-100 mb-4 ag-grid-table"
				:columnDefs="columnDefs"
				:defaultColDef="defaultColDef"
				:rowData="tableData"
				rowSelection="multiple"
				:enableRangeSelection="true"
				:suppressCopyRowsToClipboard="true"
				colResizeDefault="shift"
				:suppressDragLeaveHidesColumns="true"
				:animateRows="false"
				:floatingFilter="true"
				:pagination="true"
				:paginationPageSize="paginationPageSize"
				:suppressPaginationPanel="true"
				:suppressRowClickSelection="true"
				:rowClassRules="rowClassRules"
				:statusBar="statusBar"
				:sideBar="sideBar"
				:rowHeight="38"
				:headerHeight="40"
				@column-resized="onColumnResized">
			</ag-grid-vue>
			<div class="vx-row">
				<div class="vx-col w-full">
					<vs-pagination
					:total="totalPages"
					:max="maxPageNumbers"
					v-model="currentPage" />
				</div>
			</div>
		</div>

		<!-- ADD KEYWORDS PROMPT -->
		<vs-prompt title="Create New Keyword" :is-valid="addKeyword['value'] != '' && !errors.has('input')" @cancel="addKeyword['value']=''" @accept="createKeyword" :active.sync="addKeyword['prompt']">
			<div class="con-exemple-prompt">
				<vs-input v-model="addKeyword['value']" v-validate="{regex: '^[a-zA-Z0-9 -]+$' }" name="input" class="mt-3 w-full" placeholder="Enter keyword name" />
				<span class="text-danger text-sm" v-show="errors.has('input')">{{ errors.first('input') }}</span>
			</div>
		</vs-prompt>
	</div>
</template>

<script>
	import { AgGridVue } from "ag-grid-vue"
	import "ag-grid-enterprise";

	import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
	import '@/assets/scss/radix/extraComponents/agGridStyleOverride.scss'

	// Cell Renderer
	import CellRendererActions from './cell-renderer/CellRendererActions.vue'
	import CellRendererStatus from './cell-renderer/CellRendererStatus.vue'

	export default {
		components: {
			AgGridVue,

			// Cell Renderer
			CellRendererActions,
			CellRendererStatus,
		},
		data () {
			return {
				searchQuery: '',

				// AgGrid
				gridOptions: {},
				maxPageNumbers: 7,
				gridApi: null,
				defaultColDef: {
					sortable: true,
					resizable: true,
					suppressMenu: true,
					suppressMovable: false,
					filter: false
				},
				rowClassRules: null,
				statusBar: null,
				sideBar: null,
				columnDefs: [
					{
						headerName: 'Word',
						field: 'word',
						filter: "agTextColumnFilter",
						minWidth: 150,
						pinned: 'left',
					},
					{
						headerName: 'ID',
						field: 'id',
						minWidth: 100,
						filter: "agTextColumnFilter",
						sort: 'desc'
					},
					{
						headerName: 'Status',
						field: 'deleted_at',
						filter: false,
						minWidth: 150,
						cellClass: 'ag-column-centered',
						cellRendererFramework: 'CellRendererStatus'
					},
					{
						headerName: 'Actions',
						field: 'actions',
						minWidth: 105,
						width: 150,
						pinned: 'right',
						cellRendererFramework: 'CellRendererActions'
					}
				],
				tableData: null,

				// Cell Renderer Components
				components: {
					CellRendererActions,
					CellRendererStatus,
				},

				// Add Keyword
				addKeyword: {
					value: '',
					prompt: false
				}
			}
		},
		watch: {
			windowWidth(val) {
				// Toggle colummn movable
				this.toggleColumnMovable(val);
				// Toggle colummn pinning
				this.toggleColumnPinned(val);
			},
		},
		computed: {
			windowWidth: function(){
				return this.$store.state.windowWidth;
			},
			paginationPageSize() {
				if(this.gridApi) {
					return this.gridApi.paginationGetPageSize()
				}
				else {
					return 20
				}
			},
			totalPages() {
				if(this.gridApi) {
					return this.gridApi.paginationGetTotalPages()
				}
				else {
					return 0
				}
			},
			currentPage: {
				get() {
					if(this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
						else return 1
					},
				set(val) {
					this.gridApi.paginationGoToPage(val - 1);
				}
			},
		},
		methods: {
			toggleColumnMovable(val) {
				if(val <= 576) {
					this.defaultColDef['suppressMovable'] = true;
				}
				else {
					this.defaultColDef['suppressMovable'] = false;
				}
			},
			toggleColumnPinned(val) {
				if(val <= 576) {
					this.maxPageNumbers = 4;
					this.gridOptions.columnApi.setColumnPinned('name', null);
					this.gridOptions.columnApi.setColumnPinned('actions', null);
				}
				else {
					this.gridOptions.columnApi.setColumnPinned('name', 'left')
					this.gridOptions.columnApi.setColumnPinned('actions', 'right')
				}
			},
			onColumnResized() {
				this.gridApi.resetRowHeights();
			},
			sizeColumnsToFit() {
				this.gridApi.sizeColumnsToFit();
			},
			populateTableData() {
				// Table Data API Call
				this.$axiosSecure.get('/keywords')
					.then((response) => {
						this.tableData = response.data;
					})
					.catch(error => {
						// Error notification
						if (error.response.status == 401) {
							this.$vs.notify({
								color: 'danger',
								title: `Not authorized`,
								text: `You do not have permission to access the resource`
							});
						}
						else if (error.response.status == 403) {
							// Token invalid so logout
							this.$root.$emit('appLogout');
						}
						else {
							this.$vs.notify({
								color: 'danger',
								title: 'Something went wrong',
								text: 'Please contact the server admin'
							});
						}
						// eslint-disable-next-line no-console
						console.log(error);
					});
			},
			createKeyword() {
				this.$axiosSecure.post('/keywords', {
					'keyword': this.addKeyword.value,
				})
					.then(() => {
						this.$root.$emit('refreshPage');
						this.showCreateSuccess();
					})
					.catch(error => {
						// Error notification
						if (error.response.status == 401) {
							this.$vs.notify({
								color: 'danger',
								title: `Not authorized`,
								text: `You do not have permission to access the resource`
							});
						}
						else if (error.response.status == 403) {
							// Token invalid so logout
							this.$root.$emit('appLogout');
						}
						else {
							this.$vs.notify({
								color: 'danger',
								title: 'Something went wrong',
								text: 'Please contact the server admin'
							});
						}
						// eslint-disable-next-line no-console
						console.log(error);
					})

				// Reset dialog on API success
				this.addKeyword['value'] = '';
				this.addKeyword['prompt'] = false;
			},
			showCreateSuccess() {
				this.$vs.notify({
					color: 'success',
					title: 'Keyword Created',
					text: 'The selected keyword was successfully created'
				})
			},
		},
		beforeMount() {
			// Table Data AXIOS Call
			this.populateTableData();

			// Reset movable columns on mobile
			this.toggleColumnMovable(this.windowWidth);

			// Set Grid sidebar
			this.sideBar = {
				toolPanels: [
				{
					id: "columns",
					labelDefault: "Columns",
					labelKey: "columns",
					iconKey: "columns",
					toolPanel: "agColumnsToolPanel",
					toolPanelParams: {
						suppressRowGroups: true,
						suppressValues: true,
						suppressPivots: true,
						suppressPivotMode: true,
						suppressSideButtons: true,
						suppressColumnSelectAll: true,
						suppressColumnExpandAll: true
					}
				}
				],
			};
		},
		mounted() {
			this.gridApi = this.gridOptions.api;

			// Resize to fit columns
			this.sizeColumnsToFit();

			// Reset pinned columns on mobile
			this.toggleColumnPinned(this.windowWidth);

			// Reset pinned columns on mobile
			this.toggleColumnPinned(this.windowWidth);

			// Page Refresh Event
			this.$root.$on('refreshPage', () => {
				// Reset filters
				this.gridApi.setFilterModel(null);
				// Reset selection
				this.gridApi.deselectAll();
				// Reset sort
				this.gridApi.setSortModel([{colId: 'id', sort: 'desc'}]);
				// Table Data AXIOS Call
				this.populateTableData();
			});

			// Page Download Event
			this.$root.$on('downloadPage', () => {
				// AgGrid CSV Export
				this.gridApi.exportDataAsCsv()
			});

			// Page Add Event
			this.$root.$on('addPage', () => {
				this.addKeyword['prompt'] = true;
			});

		},
		destroyed() {			
			// Unbind Button Event Listeners
			this.$root.$off('refreshPage');
			this.$root.$off('downloadPage');
			this.$root.$off('addPage');
		}
	}

</script>
